//import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import {
  faBullseye,
  faCar,
  faChartColumn,
  faDice,
  faDraftingCompass,
  faLaughBeam,
  faMagnifyingGlass,
  faPlane,
  faRoute,
  faTools,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import React, { Suspense, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { tabs } from '../../navbar/tabs';

const iconMapping = {
  bullseye: faBullseye,
  car: faCar,
  plane: faPlane,
  tools: faTools,
  'laugh-beam': faLaughBeam,
  'magnifying-glass': faMagnifyingGlass,
  'drafting-compass': faDraftingCompass,
  'chart-column': faChartColumn,
  route: faRoute,
  dice: faDice,
};

function ListsNavigation(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [, setCurrentTab] = useState(() => {
    const foundTab = tabs.find((tab) => location.pathname === tab.link);
    return foundTab ? foundTab.name : '';
  });

  const handleTabClick = (tabName, tabLink) => {
    if (tabName === 'Trips') {
      navigate(`/lists/tools/golf-trips`);
    } else if (['Practice', 'Fun'].includes(tabName)) {
      alert("Apologies this Golf List is not ready yet. It's coming soon!");
    } else if (tabName === 'Golf Courses') {
      navigate(`/lists/golf-courses/rankings`);
    } else {
      setCurrentTab(tabName);
      navigate(tabLink);
    }
  };

  return (
    <div className="mx-auto">
      {/* Tabs */}
      {location.pathname === '/lists' && (
        <>
          <section className="mx-auto max-w-7xl">
            <h1 className="text-center mt-4 mb-10 text-3xl font-extrabold text-gray-900 sm:text-4xl">
              Explore Golf Lists
            </h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {tabs.map((tab) => (
                <div
                  key={tab.name}
                  className="flex flex-col items-center p-6 bg-white shadow-sm rounded-lg hover:shadow-md transition-shadow duration-300"
                >
                  <FontAwesomeIcon
                    icon={iconMapping[tab.icon]}
                    className="text-indigo-700 text-4xl mb-4"
                  />
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {tab.name}
                  </h3>
                  <p className="text-sm text-gray-600 mb-4 text-center">
                    {tab.description}
                  </p>
                  <button
                    className={`${tab.buttonClass} w-full mt-auto transition-colors duration-150 rounded-full text-lg font-medium py-2 px-4`}
                    onClick={() => handleTabClick(tab.name, tab.link)}
                  >
                    {tab.button}
                  </button>
                </div>
              ))}
            </div>
          </section>
        </>
      )}

      {/* Local Suspense so lazy list child routes resolve here (not root), matching GolfCoursePage eager pattern */}
      <Suspense
        fallback={
          <div
            className="mx-auto flex min-h-[40vh] max-w-4xl items-center justify-center px-4 py-12 text-gray-500"
            aria-busy="true"
            aria-live="polite"
          >
            Loading list…
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </div>
  );
}

export default ListsNavigation;
